import styled from 'styled-components';
import {Row, RowW50Styles, Column} from '../../common/Layouts/Layouts';

export const BreadcrumbDetailsLoaderWrapDiv = styled.div(
  props => `

  display:flex;
  flex-direction: row;
  max-width: 120rem;
  margin: 0 auto;
  padding: ${props.theme.spacing.base};
  justify-Content: space-between;
  width:100%;
  background-color:${props.theme.colors.goWhite.base};
  border-radius:${props.theme.misc.borderRadius.large};
  margin-top:${props.theme.spacing.xlarge};

`,
);

export const BreadcrumbHotelDetailsWrapDiv = styled.div(
  props => `

  display:flex;
  flex-direction: column;

`,
);

export const HotelInfoDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  width:20rem;
  height:3.6rem;

`,
);

export const BreadcrumbReviewDetailsWrapDiv = styled.div(
  props => `

  margin-top:${props.theme.spacing.base};

`,
);

export const HotelNameWrapDiv = styled.div(
  props => `

  display:flex;
  margin-bottom:${props.theme.spacing.base};

`,
);

export const HotelNameDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  width:44.1rem;
  height:2.7rem;

`,
);

export const HotelToolTip = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.custom(20)};
  margin-left:${props.theme.spacing.xlarge};
  width:13.3rem;
  height:2.4rem;

`,
);

export const HotelAddressDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  width:17.7rem;
  height:2.1rem;

`,
);

export const HotelReviewDiv = styled.div(
  props => `

  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  margin-bottom:${props.theme.spacing.base};
  margin-left:auto;
  width:7.6rem;
  height:4.7rem;

`,
);

export const HotelRakingDiv = styled.div(
  props => `

  display:flex;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius: ${props.theme.misc.borderRadius.small};
  width:14.2rem;
  height:1.8rem;

`,
);
